export function copy(
  texto: string | number,
  startPosition: number,
  endPosition?: number,
) {
  let retorno = '';

  if (typeof texto === 'number') texto = String(texto);
  if (!endPosition) endPosition = texto.length;

  for (let i = 0; i < texto.length; i++) {
    const index = i + 1;

    if (index >= startPosition && index <= endPosition) {
      const letra = texto[i];
      retorno += letra;
    }
  }

  return retorno;
}
